import React from "react";
import HomeConatiner from "./../containers/HomeConatiner";

function Home() {
  return <HomeConatiner></HomeConatiner>;
}

export default Home;
